/* eslint-disable prettier/prettier */
import * as gql from 'fake-tag';

export const QuizWidgetFragment = {
  Quiz: gql`
    fragment QuizWidgetQuery on externalWidget_Entry {
      styles
      vendorWidget
      externalWidgetId
      componentWidgetHeight
      typeHandle
    }
  `,
};
